import { OrchestrationConnectionType } from '@common/Fabric/Connections/types';
import { isCaseInsensitiveEqual } from '@prophecy/utils/string';

import { Providers } from './types';

export function getProviderType(providerType?: string) {
  const isDataBricks = isCaseInsensitiveEqual(Providers.Databricks, providerType);
  const isSnowFlake = isCaseInsensitiveEqual(Providers.Snowflake, providerType);
  const isBigQuery = isCaseInsensitiveEqual(Providers.BigQuery, providerType);
  const isSpark = isCaseInsensitiveEqual(Providers.Spark, providerType);
  const isTrino = isCaseInsensitiveEqual(Providers.Trino, providerType);
  const isRedshift = isCaseInsensitiveEqual(Providers.Redshift, providerType);
  const isHana = isCaseInsensitiveEqual(OrchestrationConnectionType.Hana, providerType);
  const isProphecyManaged = isCaseInsensitiveEqual(Providers.ProphecyManaged, providerType);
  return {
    isBigQuery,
    isSnowFlake,
    isDataBricks,
    isSpark,
    isTrino,
    isRedshift,
    isHana,
    providerType,
    isProphecyManaged
  };
}
